module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-232.66e1c58f.svg";